import { Component } from '@angular/core';
import { ToasterConfig } from 'angular2-toaster';

@Component({
  selector: 'daccs-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  public toasterconfig: ToasterConfig =
    new ToasterConfig({
      showCloseButton: true,
      tapToDismiss: true,
      animation: 'slideUp',
      positionClass: 'toast-bottom-right',
      timeout: 4000
    });
}



// WEBPACK FOOTER //
// /opt/build/repo/src/app/app.component.ts